document.addEventListener('DOMContentLoaded', function () {
  document.body.addEventListener('click', function (e) {
    const link = e.target.closest('.js-comments-pagination-link');
    if (!link) return;
    e.preventDefault();

    const url = link.getAttribute('href');
    const commentsContainer = document.getElementById('article-comments');
    if (!url || !commentsContainer) return;

    commentsContainer.style.opacity = '0.5';

    fetch(url)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newComments = doc.getElementById('article-comments');
        if (newComments) {
          commentsContainer.innerHTML = newComments.innerHTML;
          if (window.AOS) setTimeout(() => AOS.refreshHard(), 50);
        }
        commentsContainer.style.opacity = '1';
        window.history.pushState({}, '', url);
        window.scrollTo({ top: commentsContainer.offsetTop - 100, behavior: 'smooth' });
      });
  });
}); 